import {
  VerifierBillingRulesFormDataType,
  VerifierBillingRulesFormFields,
  VerifierBillingRulesFormValues,
} from 'src/components/verifier/VerifierBillingSettingsCVAdminManager/types';

export const getVerifierBillingRulesFormInitialValues = ({
  voI,
  voE,
  reverification,
}: VerifierBillingRulesFormDataType): VerifierBillingRulesFormValues => ({
  [VerifierBillingRulesFormFields.verificationOfIncome]: voI || 0,
  [VerifierBillingRulesFormFields.verificationOfEmployment]: voE || 0,
  [VerifierBillingRulesFormFields.reverification]: reverification || 0,
});
